/**
 * Tastierino numerico dell'app.
 *
 * Non si usa la tastiera di sistema: su telefono farebbe saltare la
 * viewport, non garantisce la virgola come separatore decimale e ha tasti
 * troppo piccoli. Qui i tasti sono grandi e sempre nello stesso posto.
 */
const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '0', 'del'] as const;

export function Keypad({ onKey }: { onKey: (key: string) => void }) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {KEYS.map((key) => (
        <button
          key={key}
          type="button"
          onClick={() => onKey(key)}
          aria-label={key === 'del' ? 'Cancella' : key}
          className="tnum h-14 rounded-[var(--radius-control)] bg-surface-2 text-xl font-medium transition active:scale-95 active:bg-border"
        >
          {key === 'del' ? '⌫' : key}
        </button>
      ))}
    </div>
  );
}

/** Applica un tasto al testo dell'importo, tenendo il formato italiano. */
export function applyKey(current: string, key: string): string {
  if (key === 'del') return current.slice(0, -1);
  if (key === ',') {
    if (current.includes(',')) return current;
    return current === '' ? '0,' : `${current},`;
  }
  // Massimo due decimali.
  const [, decimals] = current.split(',');
  if (decimals !== undefined && decimals.length >= 2) return current;
  if (current === '0') return key;
  if (current.replace(/[^\d]/g, '').length >= 9) return current;
  return current + key;
}

export function amountFromText(text: string): number {
  const n = Number(text.replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}
